import { Phone } from "lucide-react";
import { ScheduleCallButton } from "./schedule-call-button";
import { Button } from "./ui/button";

export default function Contact() {
  return (
    <section className="py-20 mb-32 bg-[rgb(7,85,158)] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white/40 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/40 rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 mb-6 border border-white/20">
          <span className="w-2 h-2 bg-white animate-pulse"></span>
          <span className="text-sm font-medium text-white/90">
            Let's Get Started
          </span>
        </div>

        {/* Main Heading */}
        <h2 className="text-3xl lg:text-5xl font-bold mb-6 leading-tight">
          Ready to Transform Your{" "}
          <span className="text-cyan-200">Business?</span>
        </h2>

        {/* Description */}
        <p className="text-cyan-100 text-md lg:text-lg leading-relaxed mb-8 max-w-3xl mx-auto">
          Let's discuss how Hexad can help you achieve your goals and drive
          meaningful growth.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a href="/contact">
            <Button
              size="lg"
              className="border-2 border-white text-white px-8 py-4 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1"
            >
              Get In Touch Today
            </Button>
          </a>
          <ScheduleCallButton
            icon={<Phone className="w-4 h-4 mr-2" />}
            className="border-2 border-white text-white px-8 py-4 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1"
            text="Schedule a Call"
          />
        </div>

        {/* Contact Methods */}
        <div className="flex flex-wrap justify-center gap-6 mt-8 text-cyan-100">
          <div className="flex items-center gap-2">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
            <span>+ (250) 792 616 714-HEXAD</span>
          </div>

         <a href="mailto:info@hexad.co.rw">
           <div className="flex items-center gap-2">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            <span>info@hexad.co.rw</span>
          </div>
         </a>
        </div>
      </div>
    </section>
  );
}
